import React, { useEffect, useState } from "react";
import api from "@/lib/api";
import { PageHeader, Money, Badge, statusTone, EmptyState } from "@/components/common";
import { ShoppingBag } from "lucide-react";

export default function AdminOrders() {
  const [orders, setOrders] = useState([]);
  useEffect(() => { api.get("/admin/orders").then(({ data }) => setOrders(data)).catch(() => setOrders([])); }, []);
  const revenue = orders.reduce((s, o) => s + (o.total || 0), 0);
  return (
    <div data-testid="admin-orders">
      <PageHeader title="Order Management" subtitle={`${orders.length} orders • ₹${revenue.toLocaleString("en-IN")} revenue`} />
      {orders.length === 0 ? <EmptyState icon={ShoppingBag} title="No orders yet" /> : (
        <div className="bg-white border border-border rounded-lg overflow-x-auto">
          <table className="w-full text-sm">
            <thead className="bg-muted text-left text-muted-foreground"><tr><th className="p-4">Order</th><th className="p-4">Customer</th><th className="p-4">Items</th><th className="p-4">Total</th><th className="p-4">Status</th><th className="p-4">Date</th></tr></thead>
            <tbody>
              {orders.map((o) => (
                <tr key={o.id} className="border-t border-border" data-testid={`admin-order-${o.id}`}>
                  <td className="p-4 font-medium text-navy">#{o.order_no}</td>
                  <td className="p-4">{o.user_name}</td>
                  <td className="p-4 text-muted-foreground max-w-[280px] truncate">{o.items?.map((i) => i.title).join(", ")}</td>
                  <td className="p-4 font-semibold"><Money amount={o.total} /></td>
                  <td className="p-4"><Badge tone={statusTone(o.status)}>{o.status}</Badge></td>
                  <td className="p-4 text-muted-foreground text-xs">{new Date(o.created_at).toLocaleString()}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
}
